import React, { Component } from "react";
import Menu from "./menu";
import "./css/setlist.css";

import setlistHeroPNG from "./images/setlist/hero.png";

class Setlist extends Component {
  render() {
    return (
      <div className="setlist-page">
        <Menu type="projects" />
        <div className="intro section-wrapper">
          <div className="section">
            <h1>Setlist</h1>
            <p>The easiest way to discover local shows using artists in your Rdio collection</p>
          </div>
          <div className="hero-wrapper">
            <img src={setlistHeroPNG} className="hero" alt="Screenshot of the Setlist app" />
          </div>
        </div>
        <div className="section-wrapper conclusion">
          <div className="section context">
            <div className="column">
              <blockquote>
                <p className="copy">"I think I've had one project go perfectly to spec and that was from Mihai"</p>
                <p className="author">
                  Bryan Maniotakis, Creative Director at{" "}
                  <a href="http://mediumrare.co" target="_blank" rel="noopener noreferrer">
                    Mediumrare
                  </a>
                </p>
              </blockquote>
              <p>
                In the summer of 2012 the talented folks at{" "}
                <a href="http://mediumrare.co" target="_blank" rel="noopener noreferrer">
                  Mediumrare
                </a>{" "}
                approached me about making their iOS app Setlist a reality. Setlist made it super easy find out if your
                favorite band was in town by taking what you listen to on Rdio and comparing it to events coming up in
                your area. Behind the polished UI was a mashup of the Rdio and Songkick APIs and all processing happened
                on the device which was a technical challenge for the resource constrained devices of the time. Sadly
                Rdio and Setlist are no more.
              </p>
              <p>Featured on: Uncrate, Swissmiss, FoxNews, Rdio, The Next Web.</p>
            </div>
            <div className="column">
              <p>
                <a href="#top" className="to-top">
                  Back to top
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Setlist;



// WEBPACK FOOTER //
// ./src/setlist.js